'use client';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import CardMedia from '@mui/material/CardMedia';
import { useId, useState } from 'react';
import { useDelayedState } from '@/hooks/useDelayedState';

type Props = {
  ads: AdDto[];
};

export const BaseAds: React.FC<Props> = (props) => {
  const id = useId();
  const [invisibles, setInvisibles] = useState<number[]>([]);
  const [ads] = useDelayedState<AdDto[]>([], props.ads);

  const onError = (i: number) => {
    if (!invisibles.includes(i)) {
      setInvisibles([...invisibles, i]);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {ads.map((ad, i) => {
        return (
          !invisibles.includes(i) && (
            <ButtonBase
              key={`ad-${id}-${i}`}
              LinkComponent="a"
              href={ad.url}
              target="_blank"
            >
              <CardMedia
                component="img"
                sx={{
                  width: '100%',
                  objectFit: 'contain'
                }}
                image={ad.imageUrl}
                alt={ad.imageTitle}
                onError={() => onError(i)}
                loading="lazy"
              />
            </ButtonBase>
          )
        );
      })}
    </Box>
  );
};
